let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "for experienced React JS Developers. Deep tech content.",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Unlimited Access to VODs',
        trackLink: 'https://geekle.us/ticket/1666860751931x232248388428496900',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "for React JS Developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1666860546476x129989540208967680',
    },
];

export default PackagesItem;
